// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsRolloverPropertyDto
 */
export interface IIsRolloverPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsRolloverPropertyDto
     */
    is_rollover?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsRolloverPropertyDto
     */
    is_rollover_state?: IIsRolloverPropertyDtoIsRolloverStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsRolloverPropertyDtoIsRolloverStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsRolloverPropertyDto interface.
 */
export function instanceOfIIsRolloverPropertyDto(value: object): value is IIsRolloverPropertyDto {
    return true;
}

export function IIsRolloverPropertyDtoFromJSON(json: any): IIsRolloverPropertyDto {
    return IIsRolloverPropertyDtoFromJSONTyped(json, false);
}

export function IIsRolloverPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsRolloverPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_rollover': json['is_rollover'] == null ? undefined : json['is_rollover'],
        'is_rollover_state': json['is_rollover_state'] == null ? undefined : json['is_rollover_state'],
    };
}

export function IIsRolloverPropertyDtoToJSON(json: any): IIsRolloverPropertyDto {
    return IIsRolloverPropertyDtoToJSONTyped(json, false);
}

export function IIsRolloverPropertyDtoToJSONTyped(value?: IIsRolloverPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_rollover': value['is_rollover'],
        'is_rollover_state': value['is_rollover_state'],
    };
}

